<template>
  <div>
    <!--  -->
    <div class="d-flex justify-content-end">
      <b-button
        variant="success"
        size="sm"
        class="mb-2"
        @click="openTransactionModal()"
      >
        <b-icon icon="plus"></b-icon>
      </b-button>
    </div>
    <b-table
      :items="transactions"
      :fields="columns"
      responsive="sm"
      hover
      striped
      bordered
      small
      show-empty
      empty-text="No transactions to show"
    >
      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="danger"
          @click="deleteTransaction(data.item)"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>
    </b-table>
    <b-modal
      id="transactionModal"
      ref="transactionModal"
      title="Register Transaction"
      size="lg"
      hide-footer
      body-class="pl-0 pr-0"
      ok-disabled
    >
      <TransactionForm
        :hide-modal="hideModal"
        @addTransaction="onAddTransaction"
      />
    </b-modal>
  </div>
</template>

<script>
import TransactionForm from "./TransactionForm.vue";
export default {
  name: "TransactionsTable",
  components: {
    TransactionForm,
  },
  props: {
    costWarning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    columns() {
      const totalColumns = [
        { key: "transactionNumber", label: "Transaction Number" },
        {
          key: "cost",
          label: "Cost",
          formatter: (amount) => this.$options.filters.currency(amount),
          class: this.costWarning ? "bg-yellow" : "",
        },
        { key: "paymentMethod", label: "Payment Method" },
        { key: "transactionType", label: "Transaction Type" },
        { key: "accountTime", label: "Account Time" },
        { key: "description", label: "Description" },
        { key: "actions", label: "Actions", class: "text-center" },
      ];
      return totalColumns;
    },
  },

  data() {
    return {
      transactions: [],
    };
  },
  methods: {
    openTransactionModal() {
      this.$bvModal.show("transactionModal");
    },
    hideModal() {
      this.$bvModal.hide("transactionModal");
    },
    onAddTransaction(transaction) {
      this.transactions.push(transaction);
      this.$emit("addTransactions", this.transactions);
    },
    deleteTransaction(transaction) {
      this.transactions = this.transactions.filter(
        (t) => t.transactionNumber !== transaction.transactionNumber
      );
      this.$emit("addTransactions", this.transactions);
    },
  },
};
</script>
